import { createRoot } from "react-dom/client";
import { useState } from "@wordpress/element";
import "./editor.scss";
import MediaList from "../components/MediaList.component";
import { Icon } from "@wordpress/components";
import svgAllFilesIcon from "../shared/svg/allFiles";
import svgImageIcon from "../shared/svg/image";
import svgAudioIcon from "../shared/svg/audio";
import svgVideoIcon from "../shared/svg/video";

/**
 * Renders a view component with tabs and content.
 *
 * @return {JSX.Element} The rendered view component.
 */
export default function View() {
	const [activeTab, setActiveTab] = useState(0);
	const rootElement = document.getElementById("rootGallery");
	const sectionStyleType = rootElement.getAttribute("data-sectionStyleType");
	const tabs = [
		{
			id: "tab-1",
			name: "mediaTypeAll",
			title: bseitEditorVars.phrases.all,
			tabComponent: (
				<MediaList
					filterType="all"
					lightboxGroupName="all"
					sectionStyleType={sectionStyleType}
				/>
			),
			icon: (
				<Icon
					icon={svgAllFilesIcon(
						"text-body group-[.active]:text-white group-hover:text-white transition-all",
					)}
				/>
			),
		},
		{
			id: "tab-2",
			name: "mediaTypeVideo",
			title: bseitEditorVars.phrases.videos,
			tabComponent: (
				<MediaList
					filterType="video"
					lightboxGroupName="typeVideo"
					sectionStyleType={sectionStyleType}
				/>
			),
			icon: (
				<Icon
					icon={svgVideoIcon(
						"text-body group-[.active]:text-white group-hover:text-white transition-all",
					)}
				/>
			),
		},
		{
			id: "tab-3",
			name: "mediaTypeImage",
			title: bseitEditorVars.phrases.images,
			tabComponent: (
				<MediaList
					filterType="image"
					lightboxGroupName="typeImage"
					sectionStyleType={sectionStyleType}
				/>
			),
			icon: (
				<Icon
					icon={svgImageIcon(
						"text-body group-[.active]:text-white group-hover:text-white transition-all",
					)}
				/>
			),
		},
		{
			id: "tab-4",
			name: "mediaTypeAudio",
			title: bseitEditorVars.phrases.audios,
			tabComponent: (
				<MediaList
					filterType="audio"
					lightboxGroupName="typeAudio"
					sectionStyleType={sectionStyleType}
				/>
			),
			icon: (
				<Icon
					icon={svgAudioIcon(
						"text-body group-[.active]:text-white group-hover:text-white transition-all",
					)}
				/>
			),
		},
		// {
		// 	id: "tab-5",
		// 	name: "mediaTypePDF",
		// 	title: bseitEditorVars.phrases.documents,
		// 	tabComponent: (
		// 		<MediaList
		// 			filterType="pdf"
		// 			lightboxGroupName="typePDF"
		// 			sectionStyleType={sectionStyleType}
		// 		/>
		// 	),
		// 	icon: (
		// 		<Icon
		// 			icon={svgFileIcon(
		// 				"text-body group-[.active]:text-white group-hover:text-white transition-all",
		// 			)}
		// 		/>
		// 	),
		// },
	];
	let tabButtonActiveClass = "";
	let tabButtonNormalClass = "";
	const buttonTypeOneClasses =
		"transition-all flex items-center border border-body rounded-3xl py-2 px-2.5 hover:bg-body hover:text-white focus:bg-body focus:text-white active:bg-body active:text-white tab-button group";
	const buttonTypeTwoClasses =
		"transition-all px-10 py-2 text-lg font-bold border-b-2 min-w-52 hover:text-primary hover:border-primary hover:font-bold focus:text-primary active:text-primary active:border-primary tab-button";
	const buttonTypeThreeClasses =
		"transition-all px-10 py-2 text-lg font-bold border-b-2 min-w-52 hover:text-primary hover:border-primary hover:font-bold focus:text-primary active:text-primary active:border-primary tab-button";

	switch (sectionStyleType) {
		case "styleOne":
			tabButtonActiveClass = `text-white bg-body ${buttonTypeOneClasses}`;
			tabButtonNormalClass = `text-darkGray bg-white ${buttonTypeOneClasses}`;
			break;
		case "styleTwo":
			tabButtonActiveClass = `border-primary text-primary ${buttonTypeTwoClasses}`;
			tabButtonNormalClass = `border-white text-darkGray ${buttonTypeTwoClasses}`;
			break;
		case "styleThree":
			tabButtonActiveClass = `border-primary text-primary ${buttonTypeThreeClasses}`;
			tabButtonNormalClass = `border-white text-darkGray ${buttonTypeThreeClasses}`;
			break;
	}

	const handleTabClick = (index) => {
		setActiveTab(index);
	};
	return (
		<>
			<div className="gap-64 mt-12 sm:flex">
				<div
					className={`flex justify-center ${
						sectionStyleType === "styleOne"
							? "flex-row-reverse"
							: "flex-row border-b border-lightGray"
					} `}
				>
					{tabs.map((tab, index) => (
						<button
							key={tab.id}
							onClick={() => handleTabClick(index)}
							type="button"
							id={tab.id}
							className={`me-4 ${
								activeTab === index
									? tabButtonActiveClass + " active "
									: tabButtonNormalClass
							}`}
							aria-label="Button"
						>
							{tab.icon && tab.icon}
							<span className="hidden object-cover mx-2.5 sm:block">
								{tab.title}
							</span>
						</button>
					))}
				</div>
			</div>
			<div className="pt-10">
				{tabs.map((tab, index) => (
					<div
						key={tab.id}
						id={`content-${tab.id}`}
						className={`${activeTab === index ? "block" : "hidden"}`}
					>
						{activeTab === index && tab.tabComponent}
					</div>
				))}
			</div>
		</>
	);
}

const root = createRoot(document.getElementById("rootGallery"));
root.render(<View />);
